export default "__VITE_ASSET__dF_tqdBA__"